import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Route,
  useLocation,
  useParams,
  useHistory,
} from 'react-router-dom/cjs/react-router-dom.min';
import { getViewerCredentials } from 'api/fetchCreds';
import styles from './styles.js';
import '@vonage/video-subscribers/video-subscribers';
import useRoom from 'hooks/useRoom.js';
import ToolBar from 'components/ToolBar/index.js';
import useScreenSharing from 'hooks/useScreenSharing.js';
import { UserContext } from '../../context/UserContext';
import WccChat from 'components/WccChat/index.js';
import { useSelector } from 'react-redux';
import { getGuestCredentials } from 'api/fetchCreds';
import PublisherToolBar from 'components/PublisherToolbar/index.js';
const SubscriberPage = () => {
  const { push } = useHistory();
  const [credentials, setCredentials] = useState(null);
  const [error, setError] = useState(null);
  let { pid, userid } = useParams();
  let subscriber = null;
  let publisher = null;
  const classes = styles();
  const { user } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  // const [tokenData, setTokenData] = useState();
  const [session, setSession] = useState();
  const [roleData, setRoleData] = useState();
  const [showScreenSharing, setShowScreenSharing] = useState(false);
  const [isScreenSharingVisible, setIsScreenSharingVisible] = useState(false);
  const [publisherAudio, setPublisherAudio] = useState(true);
  const [publisherVideo, setPublisherVideo] = useState(true);
  const [sessionLayout, setSessionLayout] = useState('');
  const [videoCount, setVideoCount] = useState(1);
  const state = useSelector((state) => state.videoRoomReducer);
  const participantState = useSelector(
    (state) => state.participantsListReducer
  );
  const roleState = useSelector((state) => state.subscriberData);
  console.log(roleState);
  console.log('isScreenSharingVisible', isScreenSharingVisible);
  const [subscriberCount, setSubscriberCount] = useState(0);
  const {
    createCall,
    room,
    participants,
    connected,
    networkStatus,
    cameraPublishing,
    localParticipant,
    audioPublishing,
  } = useRoom();
  const { isScreenSharing, startScreenSharing, stopScreenSharing } =
    useScreenSharing({ room });
  const params = useParams();

  useEffect(() => {
    if (session) {
      session.signal(
        {
          type: 'text',
          data: {
            participantList: participantState.participantsList,
            sessionData: session,
            from: 'participants',
            isHandRaised: state.raiseHand,
          },
        },
        function (error) {
          if (error) {
            console.log('signal error (' + error.name + '): ' + error.message);
          } else {
            console.log('signal sent.');
          }
        }
      );
    }
  }, [state.raiseHand]);

  useEffect(() => {
    if (sessionStorage.getItem('sessionLayout')) {
      layout = sessionStorage.getItem('sessionLayout');
    }
    if (sessionStorage.getItem('role') === 'Speaker') {
      generatePublisherToken();
    } else {
      generateSubscriberToken();
    }
  }, []);
  const toggleScreenSharing = () => {
    setIsScreenSharingVisible(!isScreenSharing);
  };
  let subscriberActivity = null;
  let layout = '';
  const sendMessageToChild = (connectionId) => {
    const iframe = document.getElementById('chatFrame');
    const jsonData = JSON.stringify(connectionId);

    iframe?.contentWindow?.postMessage(
      JSON.stringify({ action: 'connectionId', body: jsonData }),
      '*'
    );
  };

  useEffect(() => {
    const unblockAudio = () => {
      if (window.OT && window.OT.unblockAudio) {
        window.OT.unblockAudio();
        console.log('Audio unblocked');
      }
    };

    document.addEventListener('click', unblockAudio, { once: true });

    return () => {
      document.removeEventListener('click', unblockAudio);
    };
  }, []);

  const generateSubscriberToken = () => {
    if (window.publisherSession) {
      window.publisherSession.unsubscribe(window.subscriber);
      window.publisher.off();
      window.publisher.destroy();
      window.publisherSession.off();
      window.publisherSession.disconnect();
      window.publisherSession.destroy();
      window.publisher = undefined;
      window.publisherSession = undefined;
      window.subscriber = undefined;
    }
    if (window.publish) {
      window.publish.destroy();
    }
    getViewerCredentials(pid, params.username, params.userid)
      .then(({ data }) => {
        const OT = window.OT;

        const subscriberSession = OT.initSession(data.apiKey, data.sessionId);
        console.log('Subscriber created', subscriberSession);
        setSession(subscriberSession);
        window.subscriberSession = subscriberSession;
        setTimeout(() => {
          sendMessageToChild(subscriberSession?.connection?.connectionId);
        }, 5000);
        if (window.subscriberSession) {
          window.subscriberSession.on('audioLevelUpdated', (e) => {
            console.log('moderator audio session', e);
          });
        }
        subscriberSession.on({
          sessionConnected: function () {
            console.log('subscriberSession sessionConnected', data);
            // session.publish(publisher);
          },
          streamCreated: function (event) {
            if (event.stream.videoType === 'screen') {
              toggleScreenSharing();
              window.subscribe = subscriberSession.subscribe(
                event.stream,
                'screenSharing',
                {
                  insertMode: 'append',
                  width: '100%',
                  height: '100%',
                }
              );
            } else {
              window.subscriber = subscriberSession.subscribe(
                event.stream,
                'publisher',
                {
                  insertMode: 'append',
                  width: `100%`,
                  height: `100%`,
                  subscribeToAudio: true,
                }
              );
              if (window.subscriber) {
                console.log(
                  'isAudio blocked',
                  window.subscriber.isAudioBlocked()
                );
                // if (window.subscriber.isAudioBlocked()) {
                window.OT && window.OT.unblockAudio();
                console.log('subscriber audio is unblocked');
                // }
                console.log('before audio event', window.subscriber);
                window.subscriber.on('audioLevelUpdated', (event) => {
                  if (event.audioLevel > 0.2) {
                    // console.log(event.target.id)
                  }
                  let now = Date.now();
                  if (event.audioLevel > 0.2) {
                    console.log('layout inside event', layout);
                    if (!subscriberActivity && layout !== 'grid') {
                      console.log('inside empty activity condition');
                      subscriberActivity = { timestamp: now, talking: false };
                    }
                    //  else if (subscriberActivity.talking) {
                    //   console.log('inside now condition');
                    //   subscriberActivity.timestamp = now;
                    // }
                    else if (
                      now - subscriberActivity.timestamp > 1000 &&
                      layout === 'active-speaker'
                    ) {
                      //Start speaking
                      // detected audio activity for more than 1s
                      // for the first time.
                      console.log('inside event id', event.target.id);
                      subscriberActivity.timestamp = now;
                      const allDiv = document
                        .querySelector('#publisher')
                        .querySelectorAll('.OT_subscriber');

                      allDiv.forEach((item) => {
                        item.style.display = 'none';
                      });

                      subscriberActivity.talking = true;
                      const subscriberDiv = document
                        .querySelector('#publisher')
                        .querySelector(`#${event.target.id}`);
                      // console.log(subscriberDiv)
                      subscriberDiv.style.display = 'block';

                      console.log('viewer moderator audio subscriber', event);
                    }
                  } else if (
                    event.audioLevel < 0.1 &&
                    subscriberActivity &&
                    now - subscriberActivity.timestamp > 2000 &&
                    layout === 'active-speaker'
                  ) {
                    //Stop speaking
                    // console.log('inside stopped speaking');
                    // const allDiv = document
                    //   .querySelector('#publisher')
                    //   .querySelectorAll('.OT_subscriber');
                    // // console.log('alldiv', allDiv)
                    // allDiv.forEach((item) => {
                    //   item.style.display = 'block';
                    // });
                    // subscriberActivity.talking = false;
                    // const subscriberDiv = document
                    //   .querySelector('#publisher')
                    //   .querySelector(`#${event.target.id}`);
                    // // console.log(subscriberDiv)
                    // subscriberDiv.style.display = 'none';
                  } else if (layout === 'grid') {
                    // detected low audio activity for more than 3s
                    // if (subscriberActivity.talking) {
                    console.log('inside grid condition');
                    // const otherDiv = document
                    // .querySelector('#publisher')
                    // .querySelector('.OT_subscriber')
                    // otherDiv.classList.remove("hideSubscriber");
                    // console.log(otherDiv)
                    const allDiv = document
                      .querySelector('#publisher')
                      .querySelectorAll('.OT_subscriber');

                    allDiv.forEach((item) => {
                      item.style.display = 'block';
                    });

                    // }
                    subscriberActivity = null;
                  } else if (
                    subscriberActivity &&
                    now - subscriberActivity.timestamp > 3000
                  ) {
                    subscriberActivity = null;
                  }
                });
              }
            }
          },
          streamDestroyed: function (event) {
            if (event.stream.videoType === 'screen') {
              setIsScreenSharingVisible(isScreenSharingVisible);
            }
          },

          signal: handleRoleSwitch,
        });

        //subscriberSession.on('signal:roleChange', handleRoleSwitch);
        subscriberSession.connect(data.token, function (error) {
          if (error) {
            console.log(error.message);
          } else {
            console.log('session connected');
          }
        });
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  };

  let activity = null;
  const generatePublisherToken = () => {
    if (window.subscriberSession) {
      window.subscriberSession.unsubscribe(window.subscriber);
      window.subscriberSession.off();
      window.subscriberSession.disconnect();
      window.subscriberSession.destroy();
      window.subscriberSession = undefined;
      window.subscriber = undefined;
    }
    if (window.subscribe) {
      window.subscribe.destroy();
    }
    getGuestCredentials(pid, params.username, params.userid)
      .then(({ data }) => {
        const OT = window.OT;

        const publisherSession = OT.initSession(data.apiKey, data.sessionId);
        setSession(publisherSession);
        window.publisherSession = publisherSession;

        window.publisher = OT.initPublisher('publisher', {
          insertMode: 'append',
          width: '300px',
          height: '230px',
          publishAudio: true,
          publishVideo: true,
        });

        let activity = null;

        publisherSession.on({
          sessionConnected: function () {
            console.log('publisherSession sessionConnected', data);
            publisherSession.publish(window.publisher);

            setTimeout(() => {
              if (window.OT && window.OT.unblockAudio) {
                window.OT.unblockAudio();
              }
              if (window.publisher) {
                window.publisher.publishAudio(true);
                window.publisher.publishVideo(true);
              }
            }, 500);
          },
          streamCreated: function (event) {
            if (event.stream.videoType === 'screen') {
              toggleScreenSharing();
              window.publish = publisherSession.subscribe(
                event.stream,
                'screenSharing',
                {
                  insertMode: 'append',
                  width: '100%',
                  height: '100%',
                }
              );
            } else {
              setVideoCount((x) => x + 1);
              window.subscriber = publisherSession.subscribe(
                event.stream,
                'publisher',
                {
                  insertMode: 'append',
                  width: '300px',
                  height: '230px',
                }
              );

              // Attach audioLevelUpdated to each subscriber stream
              window.subscriber.on('audioLevelUpdated', (event) => {
                let now = Date.now();
                if (event.audioLevel > 0.2) {
                  if (!activity && layout !== 'grid') {
                    activity = { timestamp: now, talking: false };
                  } else if (
                    now - activity.timestamp > 1000 &&
                    layout === 'active-speaker'
                  ) {
                    // Start speaking: detected audio activity for more than 1s
                    activity.timestamp = now;
                    activity.talking = true;

                    const allDiv = document
                      .querySelector('#publisher')
                      .querySelectorAll('.OT_subscriber, .OT_publisher');
                    allDiv.forEach((item) => {
                      item.style.display = 'none';
                    });

                    const activeDiv = document
                      .querySelector('#publisher')
                      .querySelector(`#${event.target.id}`);
                    if (activeDiv) {
                      activeDiv.style.display = 'block';
                    }

                    console.log('publisher active speaker subscriber', event);
                  }
                } else if (
                  event.audioLevel < 0.1 &&
                  activity &&
                  now - activity.timestamp > 2000 &&
                  layout === 'active-speaker'
                ) {
                  // Stop speaking: no audio activity for 2s
                  activity.talking = false;
                  activity = null;
                } else if (layout === 'grid') {
                  const allDiv = document
                    .querySelector('#publisher')
                    .querySelectorAll('.OT_subscriber, .OT_publisher');
                  allDiv.forEach((item) => {
                    item.style.display = 'block';
                  });
                  activity = null;
                } else if (activity && now - activity.timestamp > 3000) {
                  activity = null;
                }
              });
            }
          },
          streamDestroyed: function (event) {
            if (event.stream.videoType === 'screen') {
              setIsScreenSharingVisible(isScreenSharingVisible);
            } else {
              setVideoCount((x) => x - 1);
            }
          },
          signal: handleRoleSwitchPublisher,
        });

        // Attach audioLevelUpdated to the publisher's own stream
        window.publisher.on('audioLevelUpdated', (event) => {
          let now = Date.now();
          if (event.audioLevel > 0.2) {
            if (!activity && layout !== 'grid') {
              activity = { timestamp: now, talking: false };
            } else if (
              now - activity.timestamp > 1000 &&
              layout === 'active-speaker'
            ) {
              // Start speaking: detected audio activity for more than 1s
              activity.timestamp = now;
              activity.talking = true;

              const allDiv = document
                .querySelector('#publisher')
                .querySelectorAll('.OT_subscriber, .OT_publisher');
              allDiv.forEach((item) => {
                item.style.display = 'none';
              });

              const publisherDiv = document
                .querySelector('#publisher')
                .querySelector(`#${event.target.id}`);
              if (publisherDiv) {
                publisherDiv.style.display = 'block';
              }

              console.log('publisher active speaker self', event);
            }
          } else if (
            event.audioLevel < 0.1 &&
            activity &&
            now - activity.timestamp > 2000 &&
            layout === 'active-speaker'
          ) {
            // Stop speaking: no audio activity for 2s
            activity.talking = false;
            activity = null;
          } else if (layout === 'grid') {
            const allDiv = document
              .querySelector('#publisher')
              .querySelectorAll('.OT_subscriber, .OT_publisher');
            allDiv.forEach((item) => {
              item.style.display = 'block';
            });
            activity = null;
          } else if (activity && now - activity.timestamp > 3000) {
            activity = null;
          }
        });

        publisherSession.connect(data.token, function (error) {
          if (error) {
            console.log(error.message);
          } else {
            console.log('session connected');
          }
        });
      })
      .catch((err) => {
        setError(err);
        console.log(err);
      });
  };
  console.log(window.subscriber);
  console.log(videoCount);
  const handleRoleSwitch = (event) => {
    console.log('signal received', event);
    if (event.data.type === 'roleChange') {
      if (
        event.data.data?.role === 'Speaker'
        // &&
        // roleData?.role !== event.data.data?.role//TODO
      ) {
        if (
          event.data.data.paramUserId === userid &&
          event.data.data?.UserId ===
            window.subscriberSession?.connection?.connectionId
        ) {
          setRoleData(event.data.data);
          generatePublisherToken();
          sessionStorage.setItem('role', event.data.data?.role);
          setShowScreenSharing(false);
        }
      } else {
        if (
          event.data.data.paramUserId === userid &&
          event.data.data?.UserId ===
            window.subscriberSession?.connection?.connectionId
        ) {
          sessionStorage.setItem('role', event.data.data?.role);
          setRoleData(event.data.data);
          generateSubscriberToken();
        }
      }
    }
    if (event.data.type === 'layout') {
      console.log('signal received for layout', event);
      sessionStorage.setItem('sessionLayout', event.data.data.layout);
      setSessionLayout(event.data.data.layout);
      layout = event.data.data.layout;
      const subscriberScreenDiv = document.getElementById('subscriber-screen');
      const subscriberToolbar = document.querySelector('.subscriber-toolbar');
      if (
        event.data.data.layout === 'screenshare-only' &&
        subscriberScreenDiv
      ) {
        subscriberScreenDiv.style.display = 'none';
        if (subscriberToolbar) {
          subscriberToolbar.classList.add('screen-toolbar');
        }
      } else if (subscriberScreenDiv) {
        subscriberScreenDiv.style.display = ''; // Reset to default
        if (subscriberToolbar) {
          subscriberToolbar.classList.remove('screen-toolbar');
        }
      }
    }
  };

  const handleRoleSwitchPublisher = (event) => {
    console.log('signal received', event);
    if (event.data.type === 'roleChange') {
      if (
        event.data.data?.role === 'Speaker'
        // &&
        // roleData?.role !== event.data.data?.role//TODO
      ) {
        if (event.data.data.paramUserId === userid) {
          generatePublisherToken();
          sessionStorage.setItem('role', event.data.data?.role);
          setRoleData(event.data.data);
          setShowScreenSharing(false);
        }
      } else {
        if (event.data.data.paramUserId === userid) {
          sessionStorage.setItem('role', event.data.data?.role);
          generateSubscriberToken();
          setRoleData(event.data.data);
          setShowScreenSharing(false);
        }
      }
    }
    if (event.data.type === 'layout') {
      console.log('signal received layout', event);
      layout = event.data.data.layout;
      sessionStorage.setItem('sessionLayout', event.data.data.layout);
      setSessionLayout(event.data.data.layout);
      const subscriberScreenDiv = document.getElementById('subscriber-screen');
      const subscriberToolbar = document.querySelector('.subscriber-toolbar');

      if (
        event.data.data.layout === 'screenshare-only' &&
        subscriberScreenDiv
      ) {
        subscriberScreenDiv.style.display = 'none';
        if (subscriberToolbar) {
          subscriberToolbar.classList.add('screen-toolbar');
        }
      } else if (subscriberScreenDiv) {
        subscriberScreenDiv.style.display = ''; // Reset to default
        if (subscriberToolbar) {
          subscriberToolbar.classList.remove('screen-toolbar');
        }
      }
    }
  };

  console.log('roledata', roleData);
  console.log('current session', session);
  console.log('layout outside', layout);
  useEffect(() => {
    if (roleData && roleData?.role === 'Speaker') {
      if (window?.publisher) {
        if (publisherAudio) {
          window.publisher.publishAudio(true);
          console.log(publisherAudio);
        } else {
          window.publisher.publishAudio(false);
        }
      }
    }
  }, [publisherAudio]);

  useEffect(() => {
    if (roleData && roleData?.role === 'Speaker') {
      if (window?.publisher) {
        if (publisherVideo) {
          window.publisher.publishVideo(true);
          console.log(publisherVideo);
        } else {
          window.publisher.publishVideo(false);
        }
      }
    }
  }, [publisherVideo]);
  const subscriberMain = document?.getElementById('subscriber-screen');
  const otDivs = subscriberMain?.querySelectorAll('div[id^="OT_"]');
  const count = otDivs?.length;
  console.log(count);

  useEffect(() => {
    const subscriberMain = document.getElementById('subscriber-screen');
    const otDivs = subscriberMain?.querySelectorAll('div[id^="OT_"]');
    setSubscriberCount(otDivs?.length || 0);

    const observer = new MutationObserver(() => {
      const updatedOtDivs = subscriberMain?.querySelectorAll('div[id^="OT_"]');
      setSubscriberCount(updatedOtDivs?.length || 0);
    });

    if (subscriberMain) {
      observer.observe(subscriberMain, { childList: true, subtree: true });
    }

    return () => observer.disconnect();
  }, [session]);
  return (
    <>
      {(roleData && roleData?.role === 'Speaker') ||
      sessionStorage.getItem('role') === 'Speaker' ? (
        <>
          <div
            className={`${
              videoCount > 3 && sessionLayout != 'active-speaker'
                ? 'publisher-more'
                : ''
            } subscriber-container ${
              (isScreenSharingVisible &&
                sessionStorage.getItem('sessionLayout') == 'grid') ||
              (isScreenSharingVisible &&
                sessionStorage.getItem('sessionLayout') == 'null') ||
              (isScreenSharingVisible && sessionLayout == 'grid')
                ? 'publisher-more-grid'
                : ''
            }`}
          >
            {/* {showScreenSharing && ( */}
            <div
              id='screenSharing'
              style={{ display: isScreenSharingVisible ? 'block' : 'none' }}
            ></div>
            {/* // )} */}
            <div
              id='subscriber-screen'
              className={`publisher-main ${
                videoCount === 2 ? 'twoSubscriber' : ''
              } ${
                videoCount === 3 && isScreenSharingVisible
                  ? 'threeSubscriber'
                  : ''
              } ${sessionLayout == 'active-speaker' ? 'twoSubscriber' : ''}`}
            >
              <div
                id='publisher'
                className={
                  isScreenSharingVisible ? 'screenshared-condition' : ''
                }
              ></div>
            </div>
          </div>
          <div className='subscriber-toolbar'>
            <div className='tool-container'>
              <PublisherToolBar
                publisherAudio={publisherAudio}
                publisherVideo={publisherVideo}
                setPublisherAudio={setPublisherAudio}
                setPublisherVideo={setPublisherVideo}
                room={window.publisher}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={`${classes.childDrawer} chat-responsive`}>
            <div className={classes.SubscriberMain}>
              <div className={classes.SubscriberWrap}>
                <div
                  className={`subscriber-container ${
                    subscriberCount > 3 ? 'subscriber-more' : ''
                  }`}
                >
                  <div
                    id='screenSharing'
                    style={{
                      display: isScreenSharingVisible ? 'block' : 'none',
                    }}
                  ></div>
                  <div id='subscriber-screen' className='subscriber-main'>
                    <div
                      id='publisher'
                      className={`subscriber-Aspect-Ratio
                        ${
                          isScreenSharingVisible ? 'screenshared-condition' : ''
                        }`}
                    ></div>
                  </div>
                </div>
              </div>
              <div className='subscriber-toolbar'>
                <div className='tool-container'>
                  <ToolBar
                    room={room}
                    participants={participants}
                    localParticipant={localParticipant}
                    connected={connected}
                    cameraPublishing={cameraPublishing}
                    isScreenSharing={isScreenSharing}
                    startScreenSharing={startScreenSharing}
                    stopScreenSharing={stopScreenSharing}
                    audioPublishing={audioPublishing}
                    open={open}
                    setOpen={setOpen}
                    //  participantId={addListData.Id}
                  />

                  {/* </div> */}
                </div>
              </div>
            </div>
            <WccChat openchat={open} />
          </div>
        </>
      )}
    </>
  );
};

export default SubscriberPage;
